
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorcycle-rentals/[slug]",
      function () {
        return require("private-next-pages/motorcycle-rentals/[slug].js");
      }
    ]);
  